// @flow
import { createAction } from '@reduxjs/toolkit';

import type { GlobalLoadingState } from '../types';

export const SUBSTEP_UPDATE = 'SUBSTEP_UPDATE';
export const SAVE_JWT = 'SAVE_JWT';
export const STEP_UPDATE = 'STEP_UPDATE';
export const GLOBAL_LOADING = 'GLOBAL_LOADING';
export const UPDATE_TITLE = 'UPDATE_TITLE';
export const OVERRIDE_BACK = 'OVERRIDE_BACK';
export const SAVE_EMAIL = 'SAVE_EMAIL';
export const SAVE_PHONE = 'SAVE_PHONE';
export const SAVE_DEPOSIT = 'SAVE_DEPOSIT';
export const SAVE_IDENTITY_SCAN = 'SAVE_IDENTITY_SCAN';
export const SAVE_CB_SCAN = 'SAVE_CB_SCAN';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const REFRESH_TOKEN_DONE = 'REFRESH_TOKEN_DONE';
export const FROM_CODE_ACTIVATION = 'FROM_CODE_ACTIVATION';
export const REDIRECT_USER = 'REDIRECT_USER';

export const globalLoading = createAction<GlobalLoadingState | false>(GLOBAL_LOADING);
